/* Movatic WMS — Mobile Move | CesarFilho 932048016 */
export default function Move() {
    return (
        <div className="py-3 grid gap-3">
            <div className="card p-3">
                <div className="font-semibold">Movimentação</div>
                <div className="text-sm text-neutral-500 mt-1">
                    Leia origem, leia destino, confirme a transferência. (com validações)
                </div>
            </div>
        </div>
    )
}
